"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validation = exports.findDexPid = void 0;
const anchor = __importStar(require("@project-serum/anchor"));
const web3_js_1 = require("@solana/web3.js");
const flex_sdk_1 = require("@zetamarkets/flex-sdk");
const findDexPid = (network) => {
    if (network === flex_sdk_1.Network.DEVNET) {
        return new web3_js_1.PublicKey("DESVgJVGajEgKGXhb6XmqDHGz3VjdgP7rEVESBgxmroY");
    }
    else {
        return new web3_js_1.PublicKey("9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin");
    }
};
exports.findDexPid = findDexPid;
class Validation {
    constructor(optionMarketKey, marketAuthorityBump) {
        this.optionMarketKey = optionMarketKey;
        this.marketAuthorityBump = marketAuthorityBump;
    }
    initOpenOrders(ix) {
        ix.data = Buffer.concat([Buffer.from([0]), ix.data]);
    }
    newOrderV3(ix) {
        ix.data = Buffer.concat([Buffer.from([1]), ix.data]);
    }
    cancelOrderV2(ix) {
        ix.data = Buffer.concat([Buffer.from([2]), ix.data]);
    }
    cancelOrderByClientIdV2(ix) {
        ix.data = Buffer.concat([Buffer.from([3]), ix.data]);
    }
    settleFunds(ix) {
        ix.data = Buffer.concat([Buffer.from([4]), ix.data]);
    }
    closeOpenOrders(ix) {
        ix.data = Buffer.concat([Buffer.from([5]), ix.data]);
    }
    prune(ix) {
        // prepend a discriminator and the marketAuthorityBump
        const bumpBuffer = new anchor.BN(this.marketAuthorityBump).toBuffer("le", 1);
        ix.data = Buffer.concat([Buffer.from([6]), bumpBuffer, ix.data]);
        // prepend the optionMarket key
        ix.keys = [
            { pubkey: this.optionMarketKey, isWritable: false, isSigner: false },
            ...ix.keys,
        ];
    }
    consumeEvents(ix) {
        return;
    }
    consumeEventsPermissioned(ix) {
        return;
    }
}
exports.Validation = Validation;
